import { loadableWithFallback } from '@vision/ui/utils';
import type { TableChart3Props } from './TableChart3';

export const TableChart3 = loadableWithFallback<TableChart3Props>(() => import('./TableChart3'));
